/*
 * NWF-228: blocks the page while the Shopify privacy banner or its preferences
 * dialog is open. Both are shown and hidden via inline display; the banner has
 * no overlay option, the preferences dialog (#shopify-pc__prefs) brings its own.
 */
(() => {
    if (window.Shopify?.designMode) return;

    const BANNER_ID = 'shopify-pc__banner';
    const PREFS_ID = 'shopify-pc__prefs';
    const KEEP_IDS = new Set([BANNER_ID, PREFS_ID]);
    const LOCK_CLASS = 'nwf-consent-lock';
    const DIM_CLASS = 'nwf-consent-dim';
    const inerted = new Set();
    const observers = new Map();

    const isOpen = (el) => !!el && el.isConnected && getComputedStyle(el).display !== 'none';

    const lock = () => {
        document.documentElement.classList.add(LOCK_CLASS);
        for (const el of document.body.children) {
            if (KEEP_IDS.has(el.id) || el.inert || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') continue;
            el.inert = true;
            inerted.add(el);
        }
    };

    const unlock = () => {
        document.documentElement.classList.remove(LOCK_CLASS);
        inerted.forEach((el) => {
            el.inert = false;
        });
        inerted.clear();
    };

    const watch = (id) => {
        const el = document.getElementById(id);
        const current = observers.get(id);
        if (current?.el === el) return el;

        current?.observer.disconnect();
        observers.delete(id);
        if (el) {
            const observer = new MutationObserver(sync);
            observer.observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
            observers.set(id, { el, observer });
        }
        return el;
    };

    function sync() {
        const bannerOpen = isOpen(watch(BANNER_ID));
        const prefsOpen = isOpen(watch(PREFS_ID));

        document.documentElement.classList.toggle(DIM_CLASS, bannerOpen && !prefsOpen);

        if (bannerOpen || prefsOpen) {
            lock();
        } else if (document.documentElement.classList.contains(LOCK_CLASS)) {
            unlock();
        }
    }

    const start = () => {
        new MutationObserver(sync).observe(document.body, { childList: true });
        document.addEventListener('visitorConsentCollected', sync);
        sync();
    };

    if (document.body) {
        start();
    } else {
        document.addEventListener('DOMContentLoaded', start, { once: true });
    }
})();
